import React from 'react';
import { Handle, Position } from 'reactflow';
import { motion } from 'framer-motion';

const ContentTypeNode = ({ data }) => {
  const { label, icon: Icon, output, active, contentType } = data;

  return (
    <motion.div
      className={`content-node ${active ? 'active' : ''}`}
      data-testid={`content-node-${contentType}`}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ type: 'spring', stiffness: 200, damping: 15 }}
    >
      <Handle
        type="target"
        position={Position.Left}
        style={{ background: active ? '#FF7F00' : '#0070FF', width: 6, height: 6 }}
      />
      
      {Icon && <Icon className="w-4 h-4" />}
      <span className="text-sm">{label}</span>
      
      <span 
        className={`text-[10px] px-2 py-0.5 rounded-full ${
          active 
            ? 'bg-white/20 text-white' 
            : 'bg-gray-100 text-gray-600'
        }`}
      >
        {output}
      </span>

      <Handle
        type="source"
        position={Position.Right}
        style={{ background: active ? '#FF7F00' : '#0070FF', width: 6, height: 6 }}
      />
    </motion.div>
  );
};

export default ContentTypeNode;
